import { styled } from '@mui/material/styles';

export const SignupHeader = styled('header')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
}));

export const SignupFooter = styled('footer')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
}));
